import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib/tanstack-error";

import {VEHICLE_CHECK_QUERY_KEYS} from "../lib/constants";
import {vehicleChecksService} from "../services";
import type {VehicleCheckLookupPayload} from "../types";

type LookupInput = {
  checkId: number;
  payload: VehicleCheckLookupPayload;
};

export function useVehicleCheckLookup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({checkId, payload}: LookupInput) =>
      vehicleChecksService.lookupVehicleCheck(checkId, payload),
    onSuccess: (result, {checkId}) => {
      queryClient.setQueryData(
        [VEHICLE_CHECK_QUERY_KEYS.detail, checkId],
        result.vehicle_check,
      );
      void queryClient.invalidateQueries({queryKey: [VEHICLE_CHECK_QUERY_KEYS.list]});
      void queryClient.invalidateQueries({queryKey: [VEHICLE_CHECK_QUERY_KEYS.infinite]});
    },
    onError: (error) => {
      errorHandler(error);
    },
  });
}
